import '@node_modules/react-modal-video/scss/modal-video.scss';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/scrollbar';
import 'swiper/css/thumbs';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

// The following import prevents a Font Awesome icon server-side rendering bug,
// where the icons flash from a very large icon down to a properly sized one:
import '@fortawesome/fontawesome-svg-core/styles.css';
// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false; /* eslint-disable import/first */

import '@styles/custom.scss';
import '@reach/skip-nav/styles.css';

import * as React from 'react';
import { GrowthBook } from '@growthbook/growthbook';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { thirdPartyTrackingPlugin, autoAttributesPlugin } from '@growthbook/growthbook/plugins';

import reduxWrapper from '@redux/wrapper';

// Growthbook
const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.GATSBY_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  plugins: [
    autoAttributesPlugin(),
    thirdPartyTrackingPlugin({ trackers: ['ga4', 'gtm'] }),
  ],
})

export const wrapRootElement = ({ element }) => {
  const reduxWrappedElement = reduxWrapper({ element })

  return (
    <GrowthBookProvider growthbook={growthbook}>
      {reduxWrappedElement}
    </GrowthBookProvider>
  )
}

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer')
    console.log('# IntersectionObserver is polyfilled!')
  }

  // Init GrowthBook on the client
  await growthbook.init({ streaming: true })
}

// Save previous pathname
const previousPath = () => {
  window.locations = window.locations || [document.referrer]
  window.locations.push(window.location.href)
  window.previousPath = locations[locations.length - 2]
}

const scrollToTop = () => {
  setTimeout(() => window.scrollTo(0, 0), 200)
}

export const onRouteUpdate = () => {
  previousPath()
  scrollToTop()
}
